import { createContext, useState } from "react";

const DisableContext = createContext({});

const DisableContextProvider = ({ children }) => {
  const [disableParty, setDisableParty] = useState(false);
  const [disableItemMaster, setDisableItemMaster] = useState(false);
  return (
    <DisableContext.Provider value={{ disableParty, setDisableParty, disableItemMaster, setDisableItemMaster }}>
      {children}
    </DisableContext.Provider>
  );
};

export { DisableContext, DisableContextProvider };
